import { IntakeLabel } from '../../entities/intake-label.interface';

export interface AishFieldErrorMessages {
  [errorCode: string]: string | IntakeLabel; //can take a normal string, or intake label variations
}

export interface AishSectionErrorMessages {
  [fieldName: string]: AishFieldErrorMessages;
}

export interface AishErrorMessageCollection {
  [sectionName: string]: AishSectionErrorMessages;
}

//define all error messages here
export const AishDefaultFallbackErrorMessage = 'This field requires your attention.';
export const AishDefaultRequiredErrorMessage = 'This field is required.';
export const AishFieldNameDisplayPlaceholder = '<<fieldNameDisplay>>';
const fieldDisplay = AishFieldNameDisplayPlaceholder; //using fieldDisplay for better readability
export const AishErrorMessages: AishErrorMessageCollection = {
  prescreen: {
    //custom error messages for prescreen can go in here
  },
  relation: {
    firstName: {
      required: AishDefaultRequiredErrorMessage,
      legalName: `${fieldDisplay} cannot contain numbers or symbols.`,
    },
    lastName: {
      required: AishDefaultRequiredErrorMessage,
      legalName: `${fieldDisplay} cannot contain numbers or symbols.`,
    },
    preferredName: {
      required: AishDefaultRequiredErrorMessage,
      legalName: `${fieldDisplay} cannot contain numbers or symbols.`,
      // legalName: {
      //   label: `${fieldDisplay} cannot contain numbers or symbols. <<oboName>>`,
      // },
    },
  },
  trustee: {
    firstName: {
      legalName: `${fieldDisplay} cannot contain numbers or symbols.`,
    },
    lastName: {
      legalName: `${fieldDisplay} cannot contain numbers or symbols.`,
    },
  },
  spouse: {
    firstName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    middleName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    lastName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    preferredName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    birthCertificateLastName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    socialInsuranceNumber: {
      shouldNotMatchCustomMessage: {
        label: `This Social Insurance Number has already been used on the Personal information page.`,
        onBehalfSpousePartnerLabel: `This Social Insurance Number has already been used on <<oboName>>'s information page.`,
      },
    },
  },
  personalInformation: {
    firstName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    middleName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    lastName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    preferredName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    birthCertificateLastName: { legalName: `${fieldDisplay} cannot contain numbers or symbols.` },
    birthdate: {
      minDate: `${fieldDisplay} is invalid. It cannot be before <<dateMin>>.`,
      maxDate: `${fieldDisplay} is invalid. It cannot be after <<birthdateMax>>.`,
    },
    socialInsuranceNumber: {
      mask: `${fieldDisplay} is invalid.`,
      mod10Validation: `${fieldDisplay} is invalid.`,
      shouldNotMatchCustomMessage: {
        label: `This Social Insurance Number has already been used on the Spouse/Partner page.`,
        onBehalfSpousePartnerLabel: `This Social Insurance Number has already been used on <<oboSpouseName>>'s information page.`,
      },
    },
    albertaHealthNumber: {
      mask: `${fieldDisplay} is invalid.`,
      mod10Validation: `${fieldDisplay} is invalid.`,
    },
    sponsorshipStartDate: {
      minDate: `${fieldDisplay} is invalid. It cannot be before <<dateMin>>.`,
      maxDate: `${fieldDisplay} is invalid. It cannot be after <<today>>.`,
    },
    sponsorshipEndDate: {
      minDate: `${fieldDisplay} is invalid. It cannot be before <<today>>.`,
    },
  },
  mySituation: {
    //custom error messages for my situation can go in here
  },
};
